import(/* webpackMode: "eager" */ "/app/src/app/company/customers/page.tsx");
